import axios from 'axios';
import { API_RefreshUserToken, API_Url, API_UserLogout } from './Assets/ApiUrlContainer';

const axiosInstance = axios.create({
    baseURL: API_Url, // API server
    // timeout: 25000,
    withCredentials: true, // Ensure cookies (session + refresh) are included in requests
});

// Flag to track if a token refresh is in progress
let isRefreshing = false;
let refreshSubscribers = [];

// Function to subscribe requests that need to be retried after refresh
const onRefreshed = () => {
    refreshSubscribers.forEach((callback) => callback());
    refreshSubscribers = [];
};

const ignoredRoutesForRedirect = ["/", "/forgot-password"]

// Request interceptor (before request is sent)
axiosInstance.interceptors.request.use(
    async (config) => {
        return config; // No changes to outgoing requests
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor (after response is received)
axiosInstance.interceptors.response.use(
    (response) => response, // If response is OK, return it
    async (error) => {
        const originalRequest = error.config;

        // If session token is expired (401 Unauthorized) and not already refreshing
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true; // Mark request as retried

            if (!isRefreshing) {
                isRefreshing = true;

                try {
                    // Call refresh token endpoint
                    console.log("Session expired. Refreshing token...");
                    await axiosInstance.post(API_RefreshUserToken);

                    isRefreshing = false;
                    onRefreshed(); // Retry queued requests

                    return axiosInstance(originalRequest); // Retry original request
                } catch (refreshError) {
                    isRefreshing = false;
                    refreshSubscribers = [];
                    console.error("Refresh token expired or invalid. Logging out...");

                    // If refresh token is also expired, log user out
                    await axiosInstance.post(API_UserLogout);
                    window.location.href = '/'; // Redirect to login page

                    return Promise.reject(refreshError);
                }
            } else {
                if (refreshSubscribers.length === 1 && !ignoredRoutesForRedirect.includes(window.location.pathname)) {
                    // log user out
                    await axiosInstance.post(API_UserLogout);
                    window.location.href = '/'; // Redirect to login page
                }

                // If a refresh is already in progress, queue the request
                return new Promise((resolve) => {
                    refreshSubscribers.push(() => {
                        resolve(axiosInstance(originalRequest));
                    });
                });
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;